(function () {
  'use strict';
  if (window.ManciniReviewsSlim) return;
  window.ManciniReviewsSlim = true;
  var selector = '[data-mancini-reviews-slim]';

  function statistics(rows, source) {
    var matching = rows.filter(function (row) { return row.s === source; });
    var rated = matching.filter(function (row) { return Number.isInteger(row.r) && row.r >= 1 && row.r <= 5; });
    return {
      count: matching.length,
      average: rated.length ? rated.reduce(function (total, row) { return total + row.r; }, 0) / rated.length : null,
      positive: matching.length ? Math.round(100 * matching.filter(function (row) { return row.c === true; }).length / matching.length) : null
    };
  }

  function scrolling(section) {
    var rail = section.querySelector('.mancini-reviews-slim__scroll');
    var link = section.querySelector('.mancini-reviews-slim__link');
    if (!rail || !link) return { refresh: function () {}, destroy: function () {} };
    var original = Array.from(link.childNodes), items = Array.from(link.querySelectorAll('.mancini-reviews-slim__item'));
    var intro = link.querySelector('.mancini-reviews-slim__intro');
    var arrow = Array.from(link.children).find(function (node) { return node !== intro && !items.includes(node); });
    var timer, fallback, destroyed = false, hovered = false, focused = false, touching = false;
    var viewport, track, position = 1, busy = false, startX = 0, startY = 0, suppressClick = false;
    var delay = Math.max(2, Math.min(15, Number(section.dataset.mrsDelay) || 4)) * 1000;
    var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var listeners = [];
    function listen(target, name, fn, options) {
      target.addEventListener(name, fn, options);
      listeners.push(function () { target.removeEventListener(name, fn, options); });
    }
    function stop() { clearTimeout(timer); }
    function schedule() {
      stop();
      if (destroyed || !track || busy || section.dataset.mrsAutoplay !== 'true' || !section.isConnected || document.hidden || hovered || focused || touching || (motion && motion.matches)) return;
      timer = setTimeout(function () { move(1); }, delay);
    }
    function paint(animate) {
      track.style.transition = animate ? 'transform 420ms ease' : 'none';
      track.style.transform = 'translateX(-' + position * 100 + '%)';
      Array.from(track.children).forEach(function (item, i) { item.setAttribute('aria-hidden', i === position && i > 0 && i <= items.length ? 'false' : 'true'); });
    }
    function finish() {
      if (!track) return;
      clearTimeout(fallback);
      if (position === items.length + 1) position = 1;
      else if (position === 0) position = items.length;
      paint(false);
      busy = false;
      schedule();
    }
    function move(direction) {
      if (!track || busy) return;
      stop(); busy = true; position += direction;
      paint(!(motion && motion.matches));
      if (motion && motion.matches) finish();
      else fallback = setTimeout(finish, 500);
    }
    function restore() {
      stop(); clearTimeout(fallback); busy = false;
      if (!track) return;
      items.forEach(function (item) { item.removeAttribute('aria-hidden'); });
      original.forEach(function (node) { link.appendChild(node); });
      viewport.remove(); viewport = null; track = null;
      section.removeAttribute('data-mrs-carousel');
    }
    function refresh() {
      if (destroyed) return;
      var current = track ? (position - 1 + items.length) % items.length : 0;
      restore();
      if (items.length < 2 || items.some(function (item) { return item.hidden; }) || rail.scrollWidth <= rail.clientWidth + 1) return;
      viewport = document.createElement('span'); viewport.className = 'mancini-reviews-slim__viewport';
      track = document.createElement('span'); track.className = 'mancini-reviews-slim__track';
      link.insertBefore(viewport, items[0]); viewport.appendChild(track);
      var panels = items.map(function (item) {
        var panel = document.createElement('span'); panel.className = 'mancini-reviews-slim__slide'; panel.appendChild(item); return panel;
      });
      if (intro) {
        var separator = document.createElement('span'); separator.className = 'mancini-reviews-slim__separator'; separator.textContent = '·'; separator.setAttribute('aria-hidden', 'true');
        panels[0].insertBefore(separator, items[0]); panels[0].insertBefore(intro, separator);
      }
      if (arrow) panels[panels.length - 1].appendChild(arrow);
      var last = panels[panels.length - 1].cloneNode(true), first = panels[0].cloneNode(true);
      last.setAttribute('data-mrs-clone', ''); first.setAttribute('data-mrs-clone', '');
      track.appendChild(last); panels.forEach(function (panel) { track.appendChild(panel); }); track.appendChild(first);
      section.dataset.mrsCarousel = 'true'; rail.scrollLeft = 0; position = current + 1; paint(false); schedule();
    }
    listen(rail, 'transitionend', function (event) { if (event.target === track && event.propertyName === 'transform') finish(); });
    listen(rail, 'mouseenter', function () { hovered = true; stop(); });
    listen(rail, 'mouseleave', function () { hovered = false; schedule(); });
    listen(rail, 'focusin', function () { focused = true; stop(); });
    listen(rail, 'focusout', function (event) { focused = rail.contains(event.relatedTarget); schedule(); });
    listen(rail, 'pointerdown', function (event) { if (!track) return; touching = true; startX = event.clientX; startY = event.clientY; suppressClick = false; stop(); });
    listen(window, 'pointerup', function (event) {
      if (!touching) return; touching = false;
      var dx = event.clientX - startX, dy = event.clientY - startY;
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) { suppressClick = true; move(dx < 0 ? 1 : -1); }
      schedule();
    });
    listen(window, 'pointercancel', function () { touching = false; schedule(); });
    listen(link, 'click', function (event) { if (suppressClick) { event.preventDefault(); suppressClick = false; } }, true);
    listen(link, 'keydown', function (event) {
      if (track && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
    });
    listen(rail, 'wheel', function (event) {
      if (track && Math.abs(event.deltaX) > Math.abs(event.deltaY)) { event.preventDefault(); if (Math.abs(event.deltaX) > 5) move(event.deltaX > 0 ? 1 : -1); }
    }, { passive: false });
    listen(document, 'visibilitychange', schedule);
    listen(window, 'resize', refresh);
    if (motion && motion.addEventListener) listen(motion, 'change', function () { if (busy) finish(); schedule(); });
    var observer = window.ResizeObserver ? new window.ResizeObserver(refresh) : null;
    if (observer) observer.observe(rail);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!destroyed) refresh(); });
    refresh();
    return {
      refresh: refresh,
      destroy: function () { destroyed = true; restore(); listeners.forEach(function (remove) { remove(); }); if (observer) observer.disconnect(); }
    };
  }

  function initialise(section) {
    if (section.dataset.mrsReady === 'true') return;
    section.dataset.mrsReady = 'true';
    var scroll = scrolling(section);
    section._manciniSlimCleanup = scroll.destroy;
    if (!section.querySelector('[data-mrs-data]')) return;
    var generation = 0;
    function put(key, value) {
      section.querySelectorAll('[data-mrs-value="' + key + '"]').forEach(function (node) { node.textContent = String(value); });
    }
    async function load() {
      var ticket = ++generation;
      var data = window.ManciniReviewsNative;
      if (!data || !data.index) {
        scroll.destroy();
        section.dataset.mrsReady = 'false';
        return;
      }
      section.setAttribute('aria-busy', 'true');
      try {
        // Same shared metadata index as the production baseline. No full review/card request.
        var rows = await data.index(section);
        if (ticket !== generation || !section.isConnected) return;
        var locale = document.documentElement.lang || 'it';
        var number = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 });
        ['google', 'facebook', 'mancini-store'].forEach(function (source) {
          var result = statistics(rows, source);
          var key = source === 'mancini-store' ? 'mancini' : source;
          put(key + '-count', result.count);
          put(key + '-rating', result.average === null ? '—' : number.format(Math.round(result.average * 10) / 10));
          if (source === 'facebook') put('facebook-positive', result.positive === null ? '—' : result.positive + '%');
          var group = section.querySelector('[data-mrs-source="' + key + '"]');
          if (group) {
            group.querySelectorAll('[data-mrs-rating]').forEach(function (node) { node.hidden = result.average === null; });
            group.querySelectorAll('[data-mrs-recommendation]').forEach(function (node) { node.hidden = result.positive === null; });
          }
        });
        put('total', rows.length);
        put('total-label', rows.length === 1 ? 'recensione' : 'recensioni');
        section.querySelectorAll('[data-mrs-data]').forEach(function (node) { node.hidden = false; });
        section.removeAttribute('data-mrs-error');
        scroll.refresh();
      } catch (error) {
        // Leave the text/link usable without showing false zeroes or an oversized error banner.
        section.dataset.mrsError = 'true';
        console.warn('[Mancini fascia recensioni]', error.message);
      } finally {
        if (ticket === generation) section.setAttribute('aria-busy', 'false');
      }
    }
    section._manciniSlimRefresh = load;
    section._manciniSlimCleanup = function () { ++generation; scroll.destroy(); };
    load();
  }

  function start(root) {
    if (root.matches && root.matches(selector)) initialise(root);
    root.querySelectorAll(selector).forEach(initialise);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
  window.addEventListener('load', function () { start(document); });
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if(event.target.matches && event.target.matches(selector) && event.target._manciniSlimCleanup) event.target._manciniSlimCleanup();
    event.target.querySelectorAll(selector).forEach(function (section) {
      if (section._manciniSlimCleanup) section._manciniSlimCleanup();
    });
  });
  window.addEventListener('online', function () {
    document.querySelectorAll(selector + '[data-mrs-error]').forEach(function (section) {
      if (section._manciniSlimRefresh) section._manciniSlimRefresh();
    });
  });
})();
